export const allergies: {
  allergyCategory: string;
  selected: boolean;
  allergyType : {
      type: string;
      selected: boolean;
  }[];
}[] = [
	{
		allergyCategory: 'Sem alergia declarada',
		selected: false,
		allergyType: [
			{
				type: 'Afirma desconhecer se possui alergias',
				selected: false

			},
			{
				type: 'Afirma não possuir alergias',
				selected: false

			}
		]
	},
	{
		allergyCategory: 'Alimentos',
		selected: false,
		allergyType: [
			{
				type: 'Camarão',
				selected: false

			},
			{
				type: 'Frutos do mar',
				selected: false

			},
			{
				type: 'Glúten',
				selected: false

			},
			{
				type: 'Lactose',
				selected: false

			},
			{
				type: 'Outros',
				selected: false

			}
		]
	},
	{
		allergyCategory: 'Antibióticos',
		selected: false,
		allergyType: [
			{
				type: 'Amoxilina',
				selected: false

			},
			{
				type: 'Ampicilina',
				selected: false

			},
			{
				type: 'Azitromicina',
				selected: false

			},
			{
				type: 'Bactrim',
				selected: false

			},
			{
				type: 'Benzetacil',
				selected: false

			},
			{
				type: 'Cefalexina',
				selected: false

			},
			{
				type: 'Cefalosporina',
				selected: false

			},
			{
				type: 'Ceftriaxona',
				selected: false

			},
			{
				type: 'Ciprofloxacina',
				selected: false

			},
			{
				type: 'Claritromicina',
				selected: false

			},
			{
				type: 'Clavulin',
				selected: false

			},
			{
				type: 'Cloranfenicol',
				selected: false

			},
			{
				type: 'Eritromicina',
				selected: false

			},
			{
				type: 'Floxacin',
				selected: false

			},
			{
				type: 'Levofloxacina',
				selected: false

			},
			{
				type: 'Macrodantina',
				selected: false

			},
			{
				type: 'Metronidazol',
				selected: false

			},
			{
				type: 'Norfloxacin',
				selected: false

			},
			{
				type: 'Penicilina',
				selected: false

			},
			{
				type: 'Piperacillin-Tazobactam',
				selected: false

			},
			{
				type: 'Quemicetina',
				selected: false

			},
			{
				type: 'Rifampicina',
				selected: false

			},
			{
				type: 'Sulfa',
				selected: false

			},
			{
				type: 'Teicoplanin',
				selected: false

			},
			{
				type: 'Tetraciclina',
				selected: false

			},
			{
				type: 'Vancomicina',
				selected: false

			},
			{
				type: 'Vibramicina',
				selected: false

			},
			{
				type: 'Outros',
				selected: false

			}
		]
	},
	{
		allergyCategory: 'Anticonvulsionantes',
		selected: false,
		allergyType: [
			{
				type: 'Fenitoina',
				selected: false

			},
			{
				type: 'Outros',
				selected: false

			}
		]
	},
	{
		allergyCategory: 'Antiemético',
		selected: false,
		allergyType: [
			{
				type: 'Metoclopramida',
				selected: false

			},
			{
				type: 'Outros',
				selected: false
			}
		]
	},
	{
		allergyCategory: 'Anti-inflamatórios',
		selected: false,
		allergyType: [
			{
				type: 'AAS',
				selected: false

			},
			{
				type: 'Ibuprofeno',
				selected: false

			},
			{
				type: 'Diclofenaco',
				selected: false

			},
			{
				type: 'Outros',
				selected: false

			}
		]
	},
	{
		allergyCategory: 'Botânicos',
		selected: false,
		allergyType: [
			{
				type: 'Pólen',
				selected: false

			},
			{
				type: 'Outros',
				selected: false

			}
		]
	},
	{
		allergyCategory: 'Contraste',
		selected: false,
		allergyType: [
			{
				type: 'Contraste Iodado',
				selected: false

			},
			{
				type: 'Gadolíneo',
				selected: false

			},
			{
				type: 'Outros',
				selected: false

			}
		]
	},
	{
		allergyCategory: 'Curativos/Bandagens',
		selected: false,
		allergyType: [
			{
				type: 'Esparadrapo',
				selected: false

			},
			{
				type: 'Micropore',
				selected: false

			},
			{
				type: 'Outros',
				selected: false

			}
		]
	},
	{
		allergyCategory: 'Opióides',
		selected: false,
		allergyType: [
			{
				type: 'Morfina',
				selected: false

			},
			{
				type: 'Tramadol',
				selected: false

			},
			{
				type: 'Outros',
				selected: false

			}
		]
	},
	{
		allergyCategory: 'Produtos Químicos',
		selected: false,
		allergyType: [
			{
				type: 'Látex',
				selected: false

			},
			{
				type: 'Outros',
				selected: false

			}
		]
	}
]
